import styled from 'styled-components';
import { palette } from 'styled-theme';

export const UploadedFileCard = styled.div`
  background: #f8fafc;
  border: 1px solid #dbe3ea;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 12px;
`;

export const FileInfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const FileName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #000;
`;

export const FileActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionButton = styled.button`
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: white;
  transition: all 0.3s ease;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  background: ${({ variant }) => (variant === 'delete' ? '#ef4444' : '#2563eb')};

  &:hover {
    opacity: ${({ disabled }) => (disabled ? 0.6 : 0.9)};
  }
`;

export const HelperText = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: 8px;
`;

export const UploadingText = styled.div`
  font-size: 13px;
  color: #2563eb;
  margin-top: 8px;
  font-weight: 500;
`;

export const UploadBox = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 6px 22px;
  border: 1px solid #6366f1;
  border-radius: 4px;
  background: #f8fbff;
  cursor: pointer;
  transition: all 0.3s ease;
  width: fit-content;

  &:hover {
    background: #eef6ff;
    border-color: #1565c0;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const UploadText = styled.span`
  font-size: 14px;
  color: #000;
  line-height: 1.2;
`;

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const FilterContainer = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  width: 360px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 999;
  border: 1px solid ${palette('border', 1)};
`;

export const Header = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f4ff;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #4b4be8;
`;

export const CloseIcon = styled.button`
  border: none;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
`;

export const Content = styled.div`
  padding: 10px 16px;
`;

export const Footer = styled.div`
  padding: 10px 16px;
  background: #f5f4ff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

export const ApplyButton = styled.button`
  padding: 10px 24px;
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const ClearButton = styled.button`
  padding: 8px 24px;
  border: 1px solid ${palette('border', 1)};
  color: #000;
  border-radius: 12px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
`;

export const LinksSection = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 12px;
  background-color: #f9fafb;
`;

export const LinkItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 8px;
  align-items: flex-end;
  padding: 12px;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const LinkInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #2563eb;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const DeleteButton = styled.button`
  padding: 8px 12px;
  background-color: #ef4444;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #dc2626;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const AddMoreButton = styled.button`
  padding: 8px 16px;
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  width: 100%;
  transition: background-color 0.2s ease;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const LinkInputLabel = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 4px;
  display: block;
`;
